import api from "./axios";

export async function getPlatformOverview() {
  const response = await api.get("/platform/overview");
  return response.data;
}

export async function listPlatformPlans() {
  const response = await api.get("/platform/plans");
  return response.data;
}

export async function listPlatformWorkspaces(params = {}) {
  const response = await api.get("/platform/workspaces", { params });
  return response.data;
}

export async function approvePlatformWorkspace(workspaceId, payload) {
  const response = await api.patch(
    `/platform/workspaces/${workspaceId}/approve`,
    payload,
  );
  return response.data;
}

export async function rejectPlatformWorkspace(workspaceId, reason) {
  const response = await api.patch(
    `/platform/workspaces/${workspaceId}/reject`,
    { reason },
  );
  return response.data;
}

export async function suspendPlatformWorkspace(workspaceId, reason) {
  const response = await api.patch(
    `/platform/workspaces/${workspaceId}/suspend`,
    { reason },
  );
  return response.data;
}

export async function reactivatePlatformWorkspace(workspaceId, payload) {
  const response = await api.patch(
    `/platform/workspaces/${workspaceId}/reactivate`,
    payload,
  );
  return response.data;
}

export async function renewPlatformWorkspace(workspaceId, payload) {
  const response = await api.patch(
    `/platform/workspaces/${workspaceId}/renew`,
    payload,
  );
  return response.data;
}


export async function permanentlyDeletePlatformWorkspace(workspaceId, payload) {
  const response = await api.delete(
    `/platform/workspaces/${workspaceId}`,
    { data: payload },
  );
  return response.data;
}

export async function listPlatformWorkspaceSubscriptions(workspaceId, params = {}) {
  const response = await api.get(
    `/platform/workspaces/${workspaceId}/subscriptions`,
    { params },
  );
  return response.data;
}

export async function listPlatformConnectors(params = {}) {
  const response = await api.get("/platform/connectors", { params });
  return response.data;
}

export async function listPlatformStores(params = {}) {
  const response = await api.get("/platform/stores", { params });
  return response.data;
}

export async function disablePlatformConnector(connectorId, reason) {
  const response = await api.patch(
    `/platform/connectors/${connectorId}/disable`,
    { reason },
  );
  return response.data;
}

export async function enablePlatformConnector(connectorId, reason) {
  const response = await api.patch(
    `/platform/connectors/${connectorId}/enable`,
    { reason },
  );
  return response.data;
}

export async function revokePlatformConnector(connectorId, reason) {
  const response = await api.patch(
    `/platform/connectors/${connectorId}/revoke`,
    { reason },
  );
  return response.data;
}

export async function getPlatformWorkspaceAIAllowance(workspaceId) {
  const response = await api.get(
    `/platform/workspaces/${workspaceId}/ai-allowance`,
  );
  return response.data;
}

export async function updatePlatformWorkspaceAIAllowance(workspaceId, payload) {
  const response = await api.patch(
    `/platform/workspaces/${workspaceId}/ai-allowance`,
    payload,
  );
  return response.data;
}

export async function addPlatformWorkspaceAIOperationTopup(workspaceId, payload) {
  const response = await api.post(
    `/platform/workspaces/${workspaceId}/ai-operation-topups`,
    payload,
  );
  return response.data;
}
